<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import { mapState } from 'vuex';
import { empty, updateTheme, clearCacheData } from 'ant-design-vue-admin-x';
export default {
  name: 'App',
  mixins: [clearCacheData],
  computed: {
    ...mapState(['defaultTheme'])
  },
  created () {
    empty.$on('setCacheData', () => {
      this.clearData();
    });

    const color = Cookies.get('themeColor');
    if (color && color !== '#1890FF') {
      this.$store.commit('TOGGLE_COLOR', color);
      updateTheme(color);
    }
  }
};
</script>

<style>
P {
  margin-bottom: 0 !important;
}
</style>
